<script>
import templateCausaRisco from './templateCausaRisco.vue'
const name = 'detalhesTemplateItem'

export default {
  name,

  components: { templateCausaRisco },

  props: {
    dataRisco: {
      type: Object,
      default: () => {}
    }
  },

  mounted () { },

  updated () { },

  data () {
    return { aprTemplateAgAprovacao: false }
  },

  methods: { },

  computed: { }

}

</script>

<template>
    <li class="d-flex w-100">
      <header>
        <div>
        <h6 class="font">{{dataRisco.riscoDescricao}}</h6>
        <div class="header-button-container">
          <p class="font"><i class="fas fa-plus"></i> NOVO RISCO</p>
          <p v-b-tooltip.hover :title="'Excluir Natureza da Causa'"><i class="fa fa-trash font"></i></p>
        </div>
        </div>
        <!-- <div div class="d-flex w-100 button-container" v-if="aprTemplateAgAprovacao === false">
          <p class="font font-bold  add" @click="popUptAdd(dataRisco.riscoId)" >ADICIONAR RISCO</p>
          <div
            class="fa fa-minus-circle exclur text-danger"
            v-b-tooltip.hover
            title="Excluir Risco e todas as Causas"
            @click="ExcluirCombo(dataRisco.riscoId)">
          </div>

        </div> -->
      </header>
      <ul>
        <templateCausaRisco
          v-for="dataCausa in dataRisco.itens"
          :key="dataCausa.causaId"
          :dataCausa="dataCausa"
        />
      </ul>
    </li>
</template>

<style scoped>
li{
  list-style-type: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

header{
  width: 100%;
  display: flex;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 0 20px;
  width: 100%;
  height: 2rem;
  background-color: #008144;
}
.header-button-container{
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.font {
  font-family: 'Segoe UI';
  font-size: 12px;
  color: #f5f5f5;
}
.add{
    width: 20%;
    cursor: pointer;
    display: flex;
    justify-content: end;
  }
  .exclur{
    width: 3%;
    cursor: pointer;
    display: flex;
    justify-content: end;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/detalhesTemplate/components/detalhesTemplateItem.vue